function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { catchError, finalize, map, of, switchMap } from 'rxjs';
import { InjectableServices } from '../enums';
import { UserStore } from '../store';
import { WindowedObservable } from '../windowed-observable';
import { AuthService } from './auth.service';
import { BaseConfigService } from './base-config.service';
export var UserService = /*#__PURE__*/ function(BaseConfigService) {
    "use strict";
    _inherits(UserService, BaseConfigService);
    function UserService() {
        _class_call_check(this, UserService);
        var _this;
        _this = _call_super(this, UserService), _define_property(_this, "baseEndpoint", void 0), _define_property(_this, "authService", AuthService.getOrCreate()), _define_property(_this, "userStore", UserStore.getOrCreate());
        _this.baseEndpoint = _this.environment.AUTH_API_URL;
        return _this;
    }
    _create_class(UserService, [
        {
            key: "getUsers",
            value: function getUsers() {
                var _this = this;
                var email = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
                this.userStore.dispatch({
                    isLoading: true
                });
                return this.axios.get("".concat(this.baseEndpoint, "/User?").concat(new URLSearchParams({
                    email: email
                }))).pipe(map(function(param) {
                    var data = param.data;
                    _this.userStore.dispatch({
                        userList: data
                    });
                    return data;
                }), finalize(function() {
                    _this.userStore.dispatch({
                        isLoading: false
                    });
                }));
            }
        },
        {
            key: "getUserByEmail",
            value: function getUserByEmail(email) {
                return this.axios.get("".concat(this.baseEndpoint, "/User/email?").concat(new URLSearchParams({
                    email: email
                }))).pipe(map(function(param) {
                    var data = param.data;
                    return data;
                }));
            }
        },
        {
            key: "getUserDetail",
            value: function getUserDetail(id) {
                var _this = this;
                this.userStore.dispatch({
                    isLoading: true
                });
                return this.axios.get("".concat(this.baseEndpoint, "/User/").concat(id)).pipe(map(function(param) {
                    var data = param.data;
                    _this.userStore.dispatch({
                        userProfile: data
                    });
                    return data;
                }), finalize(function() {
                    _this.userStore.dispatch({
                        isLoading: false
                    });
                }));
            }
        },
        {
            key: "updateUserDetail",
            value: function updateUserDetail(id, payload, updateCurrent) {
                var _this = this;
                this.userStore.dispatch({
                    isLoading: true
                });
                return this.axios.put("".concat(this.baseEndpoint, "/User/").concat(id), payload).pipe(switchMap(function(param) {
                    var data = param.data;
                    if (updateCurrent) {
                        var userProfileData = _this.userStore.userProfile;
                        _this.userStore.dispatch({
                            userProfile: _object_spread({}, userProfileData, data)
                        });
                        return _this.authService.fetchUserInfo().pipe(map(function() {}));
                    }
                    return of(data);
                }), finalize(function() {
                    _this.userStore.dispatch({
                        isLoading: false
                    });
                }));
            }
        },
        {
            key: "uploadUserAvatarImage",
            value: function uploadUserAvatarImage(formData) {
                var _this = this;
                this.userStore.dispatch({
                    isLoading: true
                });
                return this.axios.post("".concat(this.baseEndpoint, "/User/avatar"), formData).pipe(finalize(function() {
                    _this.userStore.dispatch({
                        userAvatar: formData.get('file'),
                        isLoading: false
                    });
                }));
            }
        },
        {
            key: "getUserAvatarImage",
            value: function getUserAvatarImage() {
                var _this = this;
                this.userStore.dispatch({
                    isLoading: true
                });
                return this.axios.get("".concat(this.baseEndpoint, "/User/avatar"), {
                    responseType: 'arraybuffer'
                }).pipe(map(function(param) {
                    var data = param.data;
                    _this.userStore.dispatch({
                        userAvatar: data
                    });
                    return data;
                }), catchError(function() {
                    _this.userStore.dispatch({
                        userAvatar: null
                    });
                    return of(null);
                }), finalize(function() {
                    _this.userStore.dispatch({
                        isLoading: false
                    });
                }));
            }
        },
        {
            key: "deleteUserAvatarImage",
            value: function deleteUserAvatarImage() {
                var _this = this;
                this.userStore.dispatch({
                    isLoading: true
                });
                return this.axios.delete("".concat(this.baseEndpoint, "/User/avatar")).pipe(finalize(function() {
                    _this.userStore.dispatch({
                        userAvatar: null,
                        isLoading: false
                    });
                }));
            }
        },
        {
            key: "resendInvitationEmail",
            value: function resendInvitationEmail(id) {
                var _this = this;
                this.userStore.dispatch({
                    isLoading: true
                });
                return this.axios.post("".concat(this.baseEndpoint, "/account/resend-invitation-email/").concat(id)).pipe(finalize(function() {
                    _this.userStore.dispatch({
                        isLoading: false
                    });
                }));
            }
        }
    ], [
        {
            key: "getOrCreate",
            value: function getOrCreate() {
                var observable = new WindowedObservable(InjectableServices.UserService);
                var state = observable.getLastEvent();
                if (state) {
                    return state;
                }
                var instance = new UserService();
                observable.publish(instance);
                return instance;
            }
        }
    ]);
    return UserService;
}(BaseConfigService);
